import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// @ actions
import { initAmountFilter, setMaxAmountFilter, setMinAmountFilter } from 'actions/filters'
// @ components
import { AmountFilter } from 'commonsComponents/amountFilter';

import { i18n } from 'core/i18n';

import { formatCurrency } from 'utilities/currencyHelper';

const { getLanguage } = i18n;
import {
    EURO_SYMBOL
} from 'constants/index';

import { 
    AMOUNT_FILTER_LABEL, 
    AMOUNT_FILTER_GREATER_THAN, 
    AMOUNT_FILTER_LOWER_THAN 
} from 'constants/commonsComponents'

class AmountFilterConnected extends PureComponent {
    componentDidMount() {
        const {
            filtersId, 
            filterId, 
            filterType,
            immFilter,
            initAmountFilter,
            currencySymbol,
            isTaggable
        } = this.props;
        !immFilter && initAmountFilter(filtersId, filterId, false, filterType, currencySymbol, null, null, isTaggable);
    }

    handleChangeAmountMax = (amount) => {
        const {
            filtersId,
            filterId,
            setMaxAmountFilter
        } = this.props;

        setMaxAmountFilter(filtersId, filterId, amount);
    }

    handleChangeAmountMin = (amount) => {
        const {
            filtersId,
            filterId,
            setMinAmountFilter
        } = this.props;

        setMinAmountFilter(filtersId, filterId, amount);
    }

    render() {
        const {
            immFilter,
            currencySymbol,
            amountLabel,
            greaterThan,
            lowerThan
        } = this.props;

        if (immFilter) {
            return (
                <AmountFilter
                    immFilter={immFilter}
                    onChangeMin={this.handleChangeAmountMin}
                    onChangeMax={this.handleChangeAmountMax}
                    fromValue={immFilter.get('from')}
                    toValue={immFilter.get('to')}
                    currencySymbol={formatCurrency(currencySymbol)}
                    amountLabel={amountLabel}
                    greaterThan={greaterThan}
                    lowerThan={lowerThan}
                    language={getLanguage()}
                />
            );
        } else {
            return null
        }
    }
}


AmountFilterConnected.propTypes = {
    filterId: PropTypes.string.isRequired,
    filterType: PropTypes.string,
    filtersId: PropTypes.string,
    immFilter: PropTypes.object,
    setMinAmountFilter: PropTypes.func,
    setMaxAmountFilter: PropTypes.func,
    initAmountFilter: PropTypes.func,
    onChangeMin: PropTypes.func,
    onChangeMax: PropTypes.func,
    currencySymbol: PropTypes.string,
    isTaggable: PropTypes.bool,
    amountLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    greaterThan: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    lowerThan: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};

AmountFilterConnected.defaultProps = {
    filterType: 'amountFilter',
    onChangeMin: () => null,
    onChangeMax: () => null,
    currencySymbol: EURO_SYMBOL,
    isTaggable: true,
    amountLabel: AMOUNT_FILTER_LABEL,
    greaterThan: AMOUNT_FILTER_GREATER_THAN,
    lowerThan: AMOUNT_FILTER_LOWER_THAN
}

export default connect(
    null,
    {
        initAmountFilter,
        setMaxAmountFilter,
        setMinAmountFilter
    }
)(AmountFilterConnected);